// Jour civil lu à Paris, quel que soit le fuseau de la machine (en-CA rend « AAAA-MM-JJ »).
const JOUR_PARIS = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
});

/** Jour civil à Paris (« AAAA-MM-JJ ») d'un instant (Date ou ISO) ; null s'il est illisible. Pure. */
export function jourParis(instant) {
  if (!instant) return null;
  const d = instant instanceof Date ? instant : new Date(instant);
  if (Number.isNaN(d.getTime())) return null;
  const p = {};
  JOUR_PARIS.formatToParts(d).forEach(({ type, value }) => { p[type] = value; });
  return `${p.year}-${p.month}-${p.day}`;
}

/**
 * Quand proposer « Premiers pas » à la connexion (spec § 4.3, décisions de William du 05/10/2026).
 *
 * « Plus tard » = reproposée à la première connexion d'un AUTRE jour (Paris). La règle lit `maj`,
 * écrit sur le compte par setVisite : elle vaut sur tous les onglets et tous les postes (l'ancien
 * repère par onglet, en sessionStorage, la reproposait à chaque Ctrl+clic).
 * `robot` : navigateur piloté (navigator.webdriver) — les robots de test internes ne reçoivent
 * jamais la fenêtre plein écran. `repondue` : l'invitation a déjà eu sa réponse sur cette page
 * (rien n'est écrit quand le parcours filtré est vide). `maintenant` est injecté pour les tests.
 */
export function doitProposer({
  prefsChargees, estInterne, estSuperadmin, usurpe, verrouille, robot, repondue, etat,
  maintenant = new Date(),
}) {
  if (!prefsChargees || !estInterne || estSuperadmin || usurpe || verrouille || robot || repondue) return false;
  if (!etat || etat.etat === 'propose') return true;
  if (etat.etat === 'plus_tard') {
    const jour = jourParis(etat.maj);
    // Sans date lisible, rien ne dit que c'était aujourd'hui : on repropose.
    return !jour || jour !== jourParis(maintenant);
  }
  return false;
}
